import _ from "lodash";
import HelperObject from "utils/helper-object";

const HelperString = {
	
	UUID: ( shortUUID ) =>{
		
		const uuidString = shortUUID ? 'xxxxxxxx-xxxx':  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
		
		let d = new Date().getTime();
		if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
			d += performance.now();
		}
		const uuid = uuidString.replace(/[xy]/g, function(c) {
			const r = (d + Math.random()*16)%16 | 0;
			d = Math.floor(d/16);
			return (c==='x' ? r : (r&0x3|0x8)).toString(16);
		});
		
		return uuid;
	},
	
	random: ( length = 7 ) => {
		return Math.round( ( Math.pow( 36, length + 1 ) - Math.random() * Math.pow( 36, length ) ) )
		           .toString( 36 )
		           .slice( 1 );
	},
	
	hash: ( prefix = '', ...list ) => {
		let key = '';
		
		// When the object is a string, make it an object
		for( const object of list ) {
			switch( true ) {
				case typeof object === 'string':
					key += object;
					break;
				
				case typeof object === 'number':
					key += String( object );
					break;
				
				case !HelperObject.isValid( object ):
				case _.isEmpty( object ):
					key += "not-valid";
					break;
					
				default:
					_.forEach([ 'guid', 'id', 'name', 'title' ], k => {
						const tmpValue = object[ k ];
						
						if( HelperObject.isValid( tmpValue ) ) {
							key += String( tmpValue );
							return false;
						}
					})
			}
		}
		
		return prefix +'-'+ key.replace(/[^a-z0-9]/gi,'');
	},
	
	addArrayLength: ( string = '', values = [], hide_zero = true ) => {
		let lengthLabel = -1;
		
		switch( true )
		{
			case Array.isArray( values ):
				if( values.length > 0 || hide_zero === false )
				{
					lengthLabel = values.length;
				}
				break;
			case typeof values === 'object':
				if( Object.keys( values ).length > 0 || hide_zero === false )
				{
					lengthLabel =  Object.keys( values ).length;
				}
				break;
		}
		
		if( lengthLabel !== -1 )
		{
			return `${string} [${lengthLabel}]`;
		}
		
		return string;
	},
	
	isEmptyString: (value) => {
		return typeof value == 'string' && value.length === 0;
	}
}

export default HelperString
